export default "__VITE_ASSET__XSQ6VGiz__"